/**
 * Convert branded ENS name to string
 * @param {import('./EnsType.js').EnsType} name - ENS name
 * @returns {string}
 */
// biome-ignore lint/suspicious/noShadowRestrictedNames: toString is the conventional method name for this pattern
export function toString(name) {
	return name;
}
